import request, { _POST, type ApiResult } from "@/services/request";

const BASE = "/admin/generatedCopy";

export type CopywritingDraftTextContent = {
  content?: string;
};

export type CopywritingDraftImageContent = {
  url?: string;
  source?: string;
};

export type CopywritingDraftContent = {
  text?: CopywritingDraftTextContent;
  image?: CopywritingDraftImageContent;
};

export type CopywritingDraftItem = {
  /** 内容项 ID，拖拽排序后保持不变 */
  id?: string;
  type: "text" | "image";
  draftContent?: CopywritingDraftContent;
};

export type CopywritingDraftPayload = {
  title?: string;
  items?: CopywritingDraftItem[];
};

/** 保存生成文案请求（与 Apifox GeneratedCopySrv.save 对齐） */
export type CopywritingSaveRequest = {
  /** 生成文案 ID，新建时不传或传 "0" */
  id?: string;
  headSupplierItemLink: string;
  materialIds: string[];
  styleId: string;
  draft: CopywritingDraftPayload;
  pushToGroup: boolean;
};

export type CopywritingStyleSnapshot = {
  id?: string;
  name?: string;
};

export type CopywritingRecord = {
  id: string;
  headSupplierItemLink: string;
  styleId: string;
  styleName?: string;
  promptStyle?: CopywritingStyleSnapshot;
  style?: CopywritingStyleSnapshot;
  materialIds?: string[];
  draft: CopywritingDraftPayload;
  pushToGroup: boolean;
  createdAt?: string;
  updatedAt?: string;
};

export function resolveCopywritingStyleName(record: CopywritingRecord, styleNameById?: Map<string, string>) {
  return (
    record.styleName?.trim() ||
    record.promptStyle?.name?.trim() ||
    record.style?.name?.trim() ||
    styleNameById?.get(record.styleId) ||
    ""
  );
}

export type CopywritingSaveResponse = {
  copy?: CopywritingRecord;
};

export type CopywritingListRequest = {
  headSupplierItemLink: string;
  page?: number;
  size?: number;
};

export type CopywritingListResponse = {
  list: CopywritingRecord[];
  total: string | number;
  page?: number;
  size?: number;
};

export function getCopywritingListItems(result?: ApiResult<CopywritingListResponse>) {
  return result?.data?.list ?? [];
}

export type CopywritingDeleteRequest = {
  ids: string[];
};

const saveCopywriting = (params: CopywritingSaveRequest) =>
  request<CopywritingSaveResponse, CopywritingSaveRequest>(_POST, `${BASE}/save`)(params);

const listCopywriting = (params: CopywritingListRequest) =>
  request<CopywritingListResponse, CopywritingListRequest>(_POST, `${BASE}/list`)(params);

const deleteCopywriting = (params: CopywritingDeleteRequest) =>
  request<null, CopywritingDeleteRequest>(_POST, `${BASE}/delete`)(params);

const copywritingApis = {
  saveCopywriting,
  listCopywriting,
  deleteCopywriting,
};

export default copywritingApis;
